import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class ReportPurchaseRegisterService extends GenericService {
    constructor() {
        super('/reports/purchase_register', axiosInstance);
    }
}

export default new ReportPurchaseRegisterService(); 